import { Form } from 'react-bootstrap'

export function Select({ value, options, onChange, ...otherProps }) {
    return (
        <Form.Group>
            <Form.Control as="select"
                value={value}
                onChange={(e) => {
                    onChange(e)
                }}
            >
                {options?.map(s => <option value={s.value} key={s.label}>{s.label}</option>)}
            </Form.Control>
        </Form.Group>
    )
}